/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function hideTitle(params) {
    var formatInput = function () { return ({
        visibility: 1, // 0-显示 1-不显示 2-不显示但仍占位
    }); };
    // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431112.0.0
    WVCall('TitlebarModule.setVisibility', params, { formatInput: formatInput });
}

export { hideTitle as default };
